<template>
  <div id="px-map-container">
    <!-- <img src="https://fakeimg.pl/350x250/282828/eae0d0/?text=Map" /> -->
  </div>
</template>

<script>
/* global google */
import {mapGetters} from 'vuex'
import MapGeoService, {GOOGLE_MAPS_KEY} from '@/services/MapGeoService'

const initialPosition = {lat: 25, lng: 2.213749}

export default {
  name: 'px-map',
  props: {
    countries: {
      type: Array,
      default: () => []
    },
    cities: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      map: undefined,
      markers: [],
      shapes: []
    }
  },
  watch: {
    countries: function (countries) { // TODO:
      // get removed countries
      const removedCountries = this.shapes.filter(
        s => !countries.some(c => c.id === s.id)
      )
      // remove them
      this.removeShapes(removedCountries)
      // get added countries
      const addedCountries = countries.filter(
        c => !this.shapes.some(s => c.id === s.id)
      )
      // add them
      this.addShapes(addedCountries)
    },
    cities: function (cities) { // TODO:
      // get removed cities
      const removedCities = this.markers.filter(
        m => !cities.some(c => c.id === m.id)
      )
      // remove them
      this.removeMarkers(removedCities)
      // get added cities
      const addedCities = cities.filter(
        c => !this.markers.some(m => c.id === m.id)
      )
      // add them
      this.addMarkers(addedCities)
    }
  },
  methods: {
    onMapIsReady () {
      this.map = new google.maps.Map(document.getElementById('px-map-container'), {
        center: initialPosition,
        zoom: 1,
        minZoom: 1,
        maxZoom: 15,
        zoomControl: true,
        // scaleControl: true,
        disableDefaultUI: true,
        // mapTypeControl: false,
        styles: [
          {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#f7f1df'
              }
            ]
          },
          {
            'featureType': 'landscape.natural',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#d0e3b4'
              }
            ]
          },
          {
            'featureType': 'landscape.natural.terrain',
            'elementType': 'geometry',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'poi.business',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'poi.medical',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#fbd3da'
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#bde6ab'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'geometry.stroke',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ffe15f'
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
              {
                'color': '#efd151'
              }
            ]
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'road.local',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': 'black'
              }
            ]
          },
          {
            'featureType': 'transit.station.airport',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#cfb2db'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#a2daf2'
              }
            ]
          }
        ]
      })
    },
    removeMarkers (markers) {
      this.markers = this.markers.filter(m => {
        const found = markers.find(toDelete => toDelete.id === m.id)
        if (found) {
          found.obj.setMap(null)
        }
        return !found
      })
      this.updateMapPosition()
    },
    addMarkers (cities) {
      cities.map(city => {
        MapGeoService.details(city.name_en, 'city').then(details => {
          if (details) {
            let marker = new google.maps.Marker({
              position: details.latLng,
              map: this.map
            })
            this.markers.push({id: city.id, obj: marker})
            this.updateMapPosition()
          }
        })
      })
    },
    removeShapes (shapes) {
      // TODO:
    },
    addShapes (countries) {
      countries.map(country => {
        MapGeoService.details(country.name_en, 'country').then(details => {
          // let shape = new google.maps.Polygon({})
          // this.shapes.push({id: country.id, obj: shape})
        })
      })
    },
    updateMapPosition () {
      // TODO: Migrate to MapKit JS (Apple)
      if (this.markers.length > 1) {
        let bounds = new google.maps.LatLngBounds()
        for (let i = 0; i < this.markers; i++) {
          bounds.extend(this.markers[i].obj.position)
        }
        this.map.panToBounds(bounds, 5)
        // this.map.panTo(initialPosition)
        // this.map.setZoom(1)
      } else if (this.markers.length === 1) {
        this.map.panTo(this.markers[0].obj.position)
        // this.map.setZoom(1)
      } else {
        this.map.panTo(initialPosition)
        // this.map.setZoom(1)
      }
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  beforeMount () {
    if (!window.$('#googleScript').length) {
      window.initMap = () => {
        this.onMapIsReady()
      }
      const googleMapsScript = document.createElement('script')
      googleMapsScript.setAttribute('id', 'googleScript')
      googleMapsScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&language=${this.lang}&callback=initMap`)
      document.head.appendChild(googleMapsScript)
    }
  }
}
</script>

<style lang="scss" scoped>
#px-map-container {
  width: 100%;
  height: 40vh;
}
</style>
